export const API_CHAT_URL =
  import.meta.env.VITE_API_CHAT_URL ?? "https://api_chat.weespots.fr";

export const API_URL =
  import.meta.env.VITE_API_URL ?? "https://api.weespots.com";
